import React from "react";
import Tween from "../tween/Tween";
import { useBreakpointsContext } from "../../hooks";

function ItineraryDayZero(props) {
    const { itineraryMetadata } = props;
    const { isMobile, isTablet, isDesktop } = useBreakpointsContext();

    return (
        <section className="trpr__itinerary-day-zero">
            <h2 className="trpr__itinerary-day-zero-title">Ipsum labore reprehenderit cillum in ea adipisicing.</h2>
            <div
                className="trpr__itinerary-day-zero-text"
                style={{ marginBottom: isMobile ? 9 : 0 }}
                dangerouslySetInnerHTML={{ __html: itineraryMetadata.arrivalDay }}
            />
            <Tween iconLabel="" icon="flag" type="primary" singleLine={false} divider="none">
                Proident excepteur laboris reprehenderit nulla.
            </Tween>
            <Tween
                iconLabel=""
                icon="road"
                type="primary"
                singleLine={false}
                divider={isDesktop || isTablet ? "bottom" : null}
                style={{ marginBottom: isDesktop || isTablet ? 24 : 0 }}
            >
                Aliqua proident consequat esse incididunt sint nulla exercitation. In consectetur culpa do officia esse
                incididunt elit dolor in.
                <a href="!#" target="_blank" rel="noopener noreferrer">
                    Deserunt ad laboris.
                </a>
            </Tween>
            <p className="trpr__itinerary-day-zero-text" style={{ marginTop: isMobile ? 9 : 0 }}>
                Aliquip anim non proident laboris. Esse in nostrud ipsum quis dolore tempor fugiat cillum incididunt
                sunt Lorem.
            </p>
        </section>
    );
}

export default ItineraryDayZero;
